import "@babel/polyfill";
import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import { Consumer } from "./container";
import Auth from "./utils/auth";
import KYCProvider from "./providers/kyc-provider";
import Query from "./features/form/query-form";
import AllQuery from "./features/form/all-query";
import QueryDetails from "./features/form/query-detail";
import Login from "./features/authenticate/login";
import Logout from "./features/authenticate/logout";
import Register from "./features/authenticate/register";
import Home from "./features/home/home";
import VerifyUser from "./features/authenticate/verify-user";
import ForgetPassword from "./features/password/forget-password";
import ResetPassword from "./features/password/reset-password";
import KycDetail from "./features/admin/kyc-detail";
import Reports from "./features/admin/reports";
import AuditLogs from "./features/admin/audit-logs";
import Client from "./features/form/client";
import VerifyKyc from "./features/admin/verify-kyc";
import KycStatus from "./features/form/kyc-status";
import PrivateRoute from "./private-route/private-route";
import SearchClient from "./features/client/search-client";
import RegisterCorrection from "./features/registercorrection/register-correction";
import LocationWise from "./features/locationwise/location-wise";
import AdminCreateUser from "./features/admin/admin-create-user";
import ChangePassword from "./features/password/change-password";
import AccessRights from "./features/entitlement/components/access-rights";
import ErrorComponent from "./components/Error/error";
import KycList from "./features/admin/kyc-list";
import CustomerSupplier from "./features/change-customer-supplier/change-customer-supplier";
import Downloads from "./features/downloads/downloads";
import TermsandConditions from "./features/authenticate/terms-conditions";
import Addresses from "./features/address/addresses";
import Customer from "./features/form/customer";
import ContactList from "./features/contact-list/contact-list";
import BankList from "./features/bank-list/bank-list";

class App extends Component {
  render() {
    return (
      <KYCProvider>
        <Routes>
          <Route
            path="/user/verifyToken/:token"
            element={<VerifyUser />}
          />
          <Route
            path="/user/resetPasswordTokenVerify/:token"
            element={<ResetPassword />}
          />
          <Route
            path="/Login"
            element={<Login />}
          />
          <Route
            path="/Register/:id"
            element={<Register />}
          />
          <Route
            path="/ForgetPassword"
            element={<ForgetPassword />} />
          <Route
            path="/Terms"
            element={<TermsandConditions />}
          />
          {/* The PrivateRoute component also needs to be updated for v6.
              It should render an <Outlet /> for nested routes.
              The nested routes are now defined inside the parent route element. */}
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Home>
                  <Routes>
                    <Route path="/Logout" element={<Logout />} />
                    <Route path="/ChangePassword" element={<ChangePassword />} />
                    <Route path="/Queries" element={<AllQuery />} />
                    <Route path="/downloads" element={<Downloads />} />
                    <Route path="/error" element={<ErrorComponent />} />
                    <Route
                      path="/Query/QueryDetails/:id"
                      element={<QueryDetails />}
                    />
                    {Auth.get("userType") !== "InternalUser" ? (
                      <>
                        <Route
                          path="/kyc"
                          element={
                            <Consumer>
                              {(context) => (
                                <Client functionality="KYC" context={context} />
                              )}
                            </Consumer>
                          }
                        >
                          <Route path="customer" element={<Customer functionality="Client" />} />
                          {Auth.get("role") === "06" && (    // When role is Supplier
                            <>
                              <Route path="contacts" element={<ContactList functionality="Contacts" />} />
                              <Route path="banks" element={<BankList functionality="Bank Details" />} />
                            </>
                          )}
                          <Route path="addresses" element={<Addresses functionality="Addresses" tag="" />} />
                          <Route path="businessentity" element={<Addresses functionality="Business Entity" tag="BE" />} />
                          <Route index element={<Customer functionality="Client" />} />
                        </Route>
                        <Route
                          path="/KycStatus"
                          element={
                            <Consumer>
                              {(context) => (
                                <KycStatus
                                  functionality="KYC Status"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                        <Route
                          path="/"
                          element={
                            <Consumer>
                              {(context) => (
                                <Client functionality="KYC" context={context} />
                              )}
                            </Consumer>
                          }
                        />
                        <Route path="/Query" element={<Query />} />
                      </>
                    ) : null}
                    {Auth.get("userType") === "InternalUser" ? (
                      <>
                        {Auth.get("role") === "01" ? (
                          <Route
                            path="/"
                            element={
                              <Consumer>
                                {(context) => (
                                  <AdminCreateUser
                                    functionality="User"
                                    context={context}
                                  />
                                )}
                              </Consumer>
                            }
                          />
                        ) : (
                          <Route
                            path="/"
                            element={
                              <Consumer>
                                {(context) => (
                                  <KycList
                                    functionality="KYCS"
                                    context={context}
                                  />
                                )}
                              </Consumer>
                            }
                          />
                        )}
                        <Route
                          path="/SearchClient"
                          element={
                            <Consumer>
                              {(context) => (
                                <SearchClient
                                  functionality="Search Client"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                        <Route
                          path="/RegisterCorrection"
                          element={
                            <Consumer>
                              {(context) => (
                                <RegisterCorrection
                                  functionality="Registration Correction"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                        <Route
                          path="/LocationWise"
                          element={
                            <Consumer>
                              {(context) => (
                                <LocationWise
                                  functionality="Location-wise Registration"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                        <Route
                          path="/kycs/:clientId/:clientType/*"
                          element={
                            <Consumer>
                              {(context) => (
                                <VerifyKyc
                                  functionality="KYCS"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                        <Route
                          path="/kycs"
                          element={
                            <Consumer>
                              {(context) => (
                                <KycList
                                  functionality="KYCS"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                        <Route
                          path="/kyc-detail/:formId"
                          element={<KycDetail />}
                        />
                        <Route
                          path="/AdminCreateUser"
                          element={
                            <Consumer>
                              {(context) => (
                                <AdminCreateUser
                                  functionality="User"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                        <Route
                          path="/Reports"
                          element={
                            <Consumer>
                              {(context) => (
                                <Reports
                                  functionality="Reports"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                        <Route
                          path="/AuditLogs/:clientId"
                          element={<AuditLogs />}
                        />
                        <Route
                          path="/ChangeCustomerSupplier"
                          element={
                            <Consumer>
                              {(context) => (
                                <CustomerSupplier
                                  functionality="Change Client Type"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                        <Route
                          path="/accessrights"
                          element={
                            <Consumer>
                              {(context) => (
                                <AccessRights
                                  functionality="Access Rights"
                                  context={context}
                                />
                              )}
                            </Consumer>
                          }
                        />
                      </>
                    ) : null}
                  </Routes>
                </Home>
              </PrivateRoute>
            }
          />
        </Routes>
      </KYCProvider>
    );
  }
}

export default App;
